// Client-side session memory: ONLY convenience (auto-rejoin), never a source
// of authoritative truth (SPEC.md §4: "a fresh browser with empty
// localStorage that rejoins with its team code + token sees the same room").
// If this is empty/cleared, the user simply has to enter their code again on
// the create/join screen -- the server still has the real seat/score/lives.
export interface StoredSession {
  code: string;
  token: string;
  seat: 1 | 2;
  name: string;
}

const KEY = 'pacmates.session.v1';

export function loadSession(): StoredSession | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredSession>;
    if (
      typeof parsed.code === 'string' &&
      typeof parsed.token === 'string' &&
      (parsed.seat === 1 || parsed.seat === 2) &&
      typeof parsed.name === 'string'
    ) {
      return parsed as StoredSession;
    }
    return null;
  } catch {
    return null;
  }
}

export function saveSession(session: StoredSession): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(session));
  } catch {
    // localStorage unavailable (private mode / quota) -- session simply
    // won't survive a reload; not fatal, the round still works this tab.
  }
}

export function clearSession(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
